import { scene } from '../main/scene-sidecar'
import { monsters } from '../monsters/monsters-sidecar'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'
import { monsterSelector } from '../ui/monsterSelector-sidecar'
import { testRig_common } from './testRig_common-sidecar'
import { machines } from '../machines/machines-sidecar'
import { worldSettings } from '../models/worldSettings-sidecar'
import { tileMapEditor } from '../editor/tileMapEditor-sidecar'
import { stacks } from '../entities/stacks-sidecar'

export const createTestRig_food = (x: number, y: number) => {
  let ctx = scene.getContext()

  let w = 14
  let h = 7
  let std = tilesDataShip.getStandard()

  tileMapEditor.setMode('stats')

  worldSettings.setNeedsNull()
  worldSettings.setNeeds({
    hungerRate: worldSettings.defaultNeeds.hungerRate * 10,
  })

  testRig_common.createBasicShip(x, y)

  let mc = machines.create('grower')
  machines.moveToTile(mc, ctx.mapShip, x + 7, y + 3)

  mc = machines.create('pile')
  machines.setHoldsType(mc, 'water')
  machines.moveToTile(mc, ctx.mapShip, x + 9, y + 3)
  testRig_common.addCargoToStack(mc, 5)

  mc = machines.create('pile')
  machines.setHoldsType(mc, 'food')
  machines.moveToTile(mc, ctx.mapShip, x + 11, y + 3)

  let m = monsters.create('human', 1)
  monsters.moveToTile(m, ctx.mapShip, x + 4, y + 3)
  m.isInsideShip = true
  monsters.setInSuit(m, false)
  monsterSelector.select(m)
}
